import { initSubRoutes } from '../../../../utils/router';

const RoutesEcranGestionCompteEmployes = initSubRoutes({
    route: '/gestion-employes',
    subroutes: {},
    nom: 'Gestion des employes',
});

export default RoutesEcranGestionCompteEmployes;
